import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkUserClaims } from 'shared/auth';
import { DownloadService } from 'shared/download';
import { UserClaims } from 'shared/mechanics/auth';
import { decodeSiteResolutionFunc, SiteResolutionContext } from 'shared/mechanics/site-resolution';
import { Icon, IconButton } from 'shared/ui-kit';
import { allFieldConfiguration } from '../fields';
import { preferenceSetCurrency } from '../redux/actions';

import { ScreenerStore, ScreenerStoreData, ScreenerStoreFilter, ScreenerStorePreference } from '../redux/model';
import { ScreenerExportService } from '../services/export-service';

import styles from './ScreenerHeaderComponent.module.scss';

export interface ScreenerHeaderProps {
	className: string;
}

export const ScreenerHeaderComponent = (props: ScreenerHeaderProps) => {
	const filter = useSelector<ScreenerStore, ScreenerStoreFilter>(x => x.filter);
	const preference = useSelector<ScreenerStore, ScreenerStorePreference>(x => x.preference);
	const data = useSelector<ScreenerStore, ScreenerStoreData>(x => x.data);
	const dispatch = useDispatch();

	const siteResolution = useContext(SiteResolutionContext);

	const selectedFilterValues: { systemName: string, title: string, value: string }[] = [];
	for (const fieldConfiguration of allFieldConfiguration) {
		var inputText = fieldConfiguration.tryDescribeSelectedValue(filter);
		if (inputText != null) {
			selectedFilterValues.push({ systemName: fieldConfiguration.systemName, title: fieldConfiguration.title, value: inputText });
		}
	}

	const filterComponent = decodeSiteResolutionFunc(
		siteResolution,
		() => (
			<p className="nowrap overflow-ellipse">
				{selectedFilterValues.map(x => renderFilterPart(x.systemName, x.title, x.value))}
			</p>
		),
		() => null);

	return (
		<div className={[props.className, styles.container].join(' ')}>
			<div className={styles.header}>
				<h1>ЕТФ и БПИФ</h1>
			</div>
			<div className={styles.filter}>
				{filterComponent}
			</div>
			<div className={styles.actions}>
				<IconButton icon={Icon.EXPORT} onClick={() => downloadCsv()} title='Экспорт в CSV' />
			</div>
			<div className={styles.currency}>
				<span className={styles.currency_label}>Валюта:</span>
				<select className={styles.currency_select} value={preference.currency} onChange={e => changeCurrency(e.currentTarget.value)}>
					<option value="RUB">RUB</option>
					<option value="USD">USD</option>
					<option value="EUR">EUR</option>
				</select>
			</div>
			<div className={styles.links}>
				<p className="nowrap">
					<a href="/list" className={styles.links_view}>Список</a>
					<span className={styles.links_separator}>/</span>
					<a className={[styles.links_view, styles.links_view_selected].join(' ')}>Скринер</a>
				</p>
			</div>
		</div>
	);

	function changeCurrency(newCurrency: string) {
		checkUserClaims(UserClaims.ALLOW_CURRENCY_DATA, 'Валютные метрики в подписке', () => {
			dispatch(preferenceSetCurrency(newCurrency));
		});
	}

	function downloadCsv() {
		checkUserClaims(UserClaims.ALLOW_EXPORT, 'Экспорт данных в подписке', () => {
			const csvContent = ScreenerExportService.toCsv(data.filteredEtfs)
			DownloadService.downloadContent(csvContent, 'screener.csv', 'text/csv;charset=utf-8');
		});
	}

	function renderFilterPart(systemName: string, title: string, value: string) {
		return (
			<span key={systemName} className={styles.filter_item}>
				<span className={styles.filter_item_title}>{title}:</span>
				<span className={styles.filter_item_value}>{value}</span>
			</span>
		);
	}
};
